import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import ModuloEnum from "@/core/utils/ModuloEnum"

const componentRouterView = {
    render(c) {
        return c("router-view")
    },
}

const createRegisterRoute = ({
    baseUrl,
    name,
    titleList,
    listComponent,
    menu,
    othersRoutes = [],
}) => ({
    path: baseUrl,
    component: componentRouterView,
    children: [
        {
            path: "/",
            name: `listar${name}`,
            meta: { description: titleList, menu },
            component: listComponent,
        },
        ...othersRoutes,
    ],
})

const routes = {
    path: "/compras",
    component: componentRouterView,
    meta: {
        modulo: ModuloEnum.NAO_NECESSITA_VERIFICACAO,
        sistema: 2,
        moduleName: "Compras",
        icon: "cart",
    },
    children: [
        createRegisterRoute({
            baseUrl: "requisicao-compra",
            name: "RequisicaoCompra",
            titleList: "Requisição de Compra",
            listComponent: () => import("@/modules/compra/requisicao-compra/ConsultarRequisicoes.vue"),
            menu: { name: "Requisição de Compra", permissao: PrivilegiosEnum.REQUISICAO_COMPRA_ACESSAR },
        }),
        createRegisterRoute({
            baseUrl: "autorizacao-compra",
            name: "AutorizacaoCompra",
            titleList: "Autorização de Compra",
            listComponent: () => import("@/modules/compra/autorizacao-compra/ConsultarAutorizacoes.vue"),
            menu: { name: "Autorização de Compra", permissao: PrivilegiosEnum.AUTORIZACAO_COMPRA_ACESSAR },
        }),
        createRegisterRoute({
            baseUrl: "processo-compra",
            name: "ProcessoCompra",
            titleList: "Processo de Compra",
            listComponent: () => import("@/modules/compra/processo-compra/ConsultarProcessoCompra.vue"),
            menu: { name: "Processo de Compra", permissao: PrivilegiosEnum.PROCESSO_COMPRA_ACESSAR },
        }),
    ],
}

export default routes
